export default {
  getDataChat: state => state.dataChat,
  getUserInfo: state => state.userInfo,
  getPayStatus: state => state.payStatus,
  getHppResponse:state => state.hppResponse
}
